import { BqApiProvider } from './../../providers/bq-api/bq-api';
import { Component } from '@angular/core';
import {
  IonicPage,
  NavController,
  NavParams,
  ViewController
} from 'ionic-angular';
import { ToastController } from 'ionic-angular';
import { TranslateService } from '@ngx-translate/core';

import { NeedsDiagnosisPage } from './../needs-diagnosis/needs-diagnosis';
import { ClosingSalePage } from './../closing-sale/closing-sale';

@IonicPage()
@Component({
  selector: 'page-presentation-product',
  templateUrl: 'presentation-product.html'
})
export class PresentationProductPage {
  public p26Selection: number;
  public p27Selection: number;
  public p28Selection: number;
  public p29Selection: number;
  public p30aSelection: number;
  public p30bSelection: number;
  public p31Selection: number;
  public p32Selection: number;
  public p33Selection: number;
  public p34aSelection: number;
  public p34bSelection: number;
  public p34cSelection: number;
  public p35Selection: number;
  public p36Selection: number;
  public p37Selection: number;

  public presentationComment: string;

  constructor(
    private translate: TranslateService,
    public navCtrl: NavController,
    public viewCtrl: ViewController,
    public navParams: NavParams,
    private bqApi: BqApiProvider
  ) {
    this.p26Selection = 0;
    this.p27Selection = 0;
    this.p28Selection = 0;
    this.p29Selection = 0;
    this.p30aSelection = 0;
    this.p30bSelection = 0;
    this.p31Selection = 0;
    this.p32Selection = 0;
    this.p33Selection = 0;
    this.p34aSelection = 0;
    this.p34bSelection = 0;
    this.p34cSelection = 0;
    this.p35Selection = 0;
    this.p36Selection = 0;
    this.p37Selection = 0;
    this.presentationComment = '';
  }

  ionViewDidLoad() {
    this.p26Selection = this.bqApi.getStep(26) || 0;
    this.p27Selection = this.bqApi.getStep(27) || 0;
    this.p28Selection = this.bqApi.getStep(28) || 0;
    this.p29Selection = this.bqApi.getStep(29) || 0;
    this.p30aSelection = this.bqApi.getStep(30) || 0;
    this.p30bSelection = this.bqApi.getStep(301) || 0;
    this.p31Selection = this.bqApi.getStep(31) || 0;
    this.p32Selection = this.bqApi.getStep(32) || 0;
    this.p33Selection = this.bqApi.getStep(33) || 0;
    this.p34aSelection = this.bqApi.getStep(34) || 0;
    this.p34bSelection = this.bqApi.getStep(341) || 0;
    this.p34cSelection = this.bqApi.getStep(342) || 0;
    this.p35Selection = this.bqApi.getStep(35) || 0;
    this.p36Selection = this.bqApi.getStep(36) || 0;
    this.p37Selection = this.bqApi.getStep(37) || 0;
    this.presentationComment = this.bqApi.getComment(4) || '';
  }

  updateSteps() {
    if (this.p26Selection !== 0) {
      this.bqApi.setStep(26, this.p26Selection);
    }

    if (this.p27Selection !== 0) {
      this.bqApi.setStep(27, this.p27Selection);
    }

    if (this.p28Selection !== 0) {
      this.bqApi.setStep(28, this.p28Selection);
    }

    if (this.p29Selection !== 0) {
      this.bqApi.setStep(29, this.p29Selection);
    }

    if (this.p30aSelection !== 0) {
      this.bqApi.setStep(30, this.p30aSelection);
    }

    if (this.p30bSelection !== 0) {
      this.bqApi.setStep(301, this.p30bSelection);
    }

    if (this.p31Selection !== 0) {
      this.bqApi.setStep(31, this.p31Selection);
    }

    if (this.p32Selection !== 0) {
      this.bqApi.setStep(32, this.p32Selection);
    }

    if (this.p33Selection !== 0) {
      this.bqApi.setStep(33, this.p33Selection);
    }

    if (this.p34aSelection !== 0) {
      this.bqApi.setStep(34, this.p34aSelection);
    }

    if (this.p34bSelection !== 0) {
      this.bqApi.setStep(341, this.p34bSelection);
    }

    if (this.p34cSelection !== 0) {
      this.bqApi.setStep(342, this.p34cSelection);
    }

    if (this.p35Selection !== 0) {
      this.bqApi.setStep(35, this.p35Selection);
    }

    if (this.p36Selection !== 0) {
      this.bqApi.setStep(36, this.p36Selection);
    }

    if (this.p37Selection !== 0) {
      this.bqApi.setStep(37, this.p37Selection);
    }

    if( this.presentationComment !== '' ){
      this.bqApi.setComment(4, this.presentationComment );
    }

    this.bqApi.syncSteps();
  }

  nextStep() {
    this.updateSteps();
    this.viewCtrl.dismiss();
    this.navCtrl.push(ClosingSalePage);
  }

  previousStep() {
    this.updateSteps();
    this.viewCtrl.dismiss();
    this.navCtrl.push(NeedsDiagnosisPage);
  }
}



// WEBPACK FOOTER //
// ./src/pages/presentation-product/presentation-product.ts